import type { Network, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import type { FindById, FindByIdThrows } from '../findById';
import { getCurrentNetworkId } from '../session/selectors';

/**
 * @deprecated PERFORMANCE This selects an entity object and will return a new object instance when it changes,
 * causing unnecessary re-renders in consuming components. This should be replaced by a `getNetworkField` selector.
 */
export const findById: FindById<'networks'> = createFindById('networks');
/**
 * @deprecated PERFORMANCE This selects an entity object and will return a new object instance when it changes,
 * causing unnecessary re-renders in consuming components. This should be replaced by a `getNetworkFieldThrows` selector.
 */
export const findByIdThrows: FindByIdThrows<'networks'> = createFindByIdThrows('networks');

type GetCurrentNetwork = (state: YammerState) => Network;
/**
 * @deprecated PERFORMANCE This selects an entity object and will return a new object instance when it changes,
 * causing unnecessary re-renders in consuming components. This should be replaced by a `getCurrentNetworkField` selector.
 */
export const getCurrentNetwork: GetCurrentNetwork = (state) => {
  const currentNetworkId = getCurrentNetworkId(state);

  return findByIdThrows(state, currentNetworkId);
};

type GetNetworkPermalinkById = (state: YammerState, networkId: Network['id']) => Network['permalink'] | undefined;
export const getNetworkPermalinkById: GetNetworkPermalinkById = (state, networkId) => {
  const network = findById(state, networkId);

  return network?.permalink;
};
